module.exports = __webpack_public_path__ + "static/media/website.ecddb1cb.svg";